import { FormHelperText, InputLabel } from "@mui/material";
import IntlTelInput from "react-intl-tel-input-18";

type ComponentProps = {
  isPhoneNumberValid: boolean;
  onChange: any;
  onBlur: any;
  value?: string;
  disabled?: boolean;
  name: string;
};

const CustomIntlTelInput = (props: ComponentProps) => {
  const { isPhoneNumberValid, onChange, onBlur, value, disabled, name } = props;

  const handlePhoneNumberChange = (
    isValid: boolean,
    value: string,
    countryData: any
  ) => {
    let fullFormattedNumber = value;
    let overrideValid = isValid;

    if (value !== "" && !value.includes("+")) {
      const dialCode = countryData.dialCode.toString();
      const digitsOnly = value.replace(/\D/g, "");

      // Find if some suffix of dialCode is a prefix of digitsOnly
      // This happens with NANP countries (like American Samoa +1-684)
      // where the area code is often included in the national format.
      let overlap = "";
      for (let i = Math.min(dialCode.length, digitsOnly.length); i > 0; i--) {
        const dcSuffix = dialCode.slice(-i);
        const nvPrefix = digitsOnly.slice(0, i);
        if (dcSuffix === nvPrefix) {
          overlap = dcSuffix;
          break;
        }
      }

      if (overlap) {
        // e.g. dialCode="1684", digitsOnly="6847331246", overlap="684"
        // prefix = "1"
        // result = "+1 (684) 733-1246"
        const prefix = dialCode.substring(0, dialCode.length - overlap.length);
        fullFormattedNumber = `+${prefix}${prefix ? " " : ""}${value}`;

        // Manual validation override: If the library flags it invalid but it has 
        // 10 digits (Standard NANP), we consider it valid despite the redundant prefix.
        if (!isValid && digitsOnly.length === 10) {
          overrideValid = true;
        }
      } else {
        fullFormattedNumber = `+${dialCode} ${value}`;
      }
    }
    onChange(overrideValid, fullFormattedNumber, countryData);
  };

  return (
    <div style={{ marginBottom: "24px" }}>
      <IntlTelInput
        disabled={disabled ?? false}
        defaultCountry="us"
        containerClassName="intl-tel-input intl-tel-container-custom"
        separateDialCode={true}
        preferredCountries={["us"]}
        inputClassName={`intl-tel-input-custom ${
          !isPhoneNumberValid && !disabled ? "invalid" : ""
        } ${disabled ? "disabled" : ""}`}
        onPhoneNumberChange={handlePhoneNumberChange}
        onSelectFlag={(
					currentNumber: string,
					selectedCountryData: any,
					fullNumber: string,
					isValid: boolean
				) =>
					handlePhoneNumberChange(isValid, currentNumber, selectedCountryData)
				}
        formatOnInit={true}
        onPhoneNumberBlur={onBlur}
        useMobileFullscreenDropdown={false}
        format={true}
        {...(value !== "" && { defaultValue: value })}
        fieldName={name}
      />
      <FormHelperText error id="component-error-text">
        <>
          {!isPhoneNumberValid && !disabled
            ? value != ""
              ? "Enter valid phone number"
              : "Phone number is required"
            : ""}
        </>
      </FormHelperText>
    </div>
  );
};

export default CustomIntlTelInput;
